/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgZoomTo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M4.5 4.5H9V3H4.5S3 3 3 4.5V9h1.5zM19.5 9V4.5H15V3h4.5C21 3 21 4.5 21 4.5V9zM15 19.5h4.5V15H21v4.5c0 1.5-1.5 1.5-1.5 1.5H15zM4.5 15v4.5H9V21H4.5C3 21 3 19.5 3 19.5V15z" /></svg>;
export default SvgZoomTo;